export default (theme) => ({
  container: {
    padding: 10,
    marginTop: 16,
  },
});
